module.exports = __webpack_public_path__ + "static/media/list-asset.a271528a.png";